// English strings of the listener panel (decision D13: English first). Another
// language adds a file next to this one with the same shape.

export const strings = {
  title: "Listener",
  legend: "Where you hear the engine from",
  default: (name: string) => `Default (${name})`,
  defaultHint: "The engine's usual position.",
  none: "This engine has no listener positions: you hear it direct.",
  synthetic: "Rooms are synthetic stand-ins until the recordings bring measured ones.",
} as const;
